import fitvids from "fitvids";

function Videos() {

	fitvids(".video");
}

export default Videos;